import React, { useEffect, useState } from 'react'
import styles from './editPaymentMethod.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'
import Cvc from '../../../../../icons/cvc.svg'
import Loading from '../../../../../icons/loading.svg'
import Stripe from '../../../../../icons/stripe.svg'
import { Link } from 'react-router-dom'
import {
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js'
import {
  paymentSetUpIntentSubscription,
  updatePaymentMethod,
} from '../../../../../api/paymentApi'
import { closeConfirmationModal } from '../../../../../redux/actions/confirmationModal'
import log from 'eslint-plugin-react/lib/util/log'
import { setUserDetails } from '../../../../../redux/actions/authActions'
import { setToastNotification } from '../../../../../redux/actions/toastNotification'

const EditPaymentMethod = () => {
  const dispatch = useDispatch()
  const elements = useElements()
  const stripe = useStripe()
  const {
    userDetails: { email },
  } = useSelector((state) => state)
  const [clientSecret, setClientSecret] = useState(null)
  const [name, setName] = useState('')
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [errors, setErrors] = useState({
    numberErr: '',
    cvcErr: '',
    expDateErr: '',
    nameErr: '',
    stripeErrorMessage: '',
  })
  const arr = ['numberErr', 'expDateErr', 'cvcErr']
  const [touched, setTouched] = useState({
    numberTouched: false,
    expDateTouched: false,
    cvcTouched: false,
    nameTouched: false,
  })
  const disabled =
    errors.numberErr ||
    errors.nameErr ||
    errors.cvcErr ||
    errors.expDateErr ||
    !touched.numberTouched ||
    !touched.expDateTouched ||
    !touched.cvcTouched ||
    !touched.nameTouched
  const CARD_ELEMENT_OPTIONS = {
    showIcon: true,
    hidePostalCode: true,
    style: {
      base: {
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '400',
        // fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        iconColor: '#666',
        '::placeholder': {
          color: '#A29DB0',
        },
      },
      invalid: {
        color: '#F14055',
        borderColor: '#F14055',
        ':focus': {
          color: '#F14055',
          borderColor: '#F14055',
        },
      },
    },
  }
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  useEffect(() => {
    !clientSecret &&
      paymentSetUpIntentSubscription(true)
        .then((data) => {
          setClientSecret(data.token)
        })
        .catch((err) => console.log(err))
  }, [])
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleConfirm()
    }
  }
  const handleName = (e, field) => {
    const value = e.currentTarget.value
    setTouched({
      ...touched,
      [field + 'Touched']: value?.trim() ? true : false,
    })
    setName(value)
  }
  const handleConfirm = (e) => {
    setDisabledBtn(true)
    e.preventDefault()
    const { setupIntent, error } = stripe
      .confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: name,
            email: email,
          },
        },
      })
      .then((res) => {
        const body = { paymentMethodId: res.setupIntent?.payment_method }
        updatePaymentMethod(body)
          .then((data) => {
            dispatch(setUserDetails({ subscriptionDetails: data }))
            dispatch(
              setToastNotification({
                type: 'success',
                toastTittle: 'Änderung gespeichert',
                toastBody: 'Ihre Profiländerung wurde erfolgreich übernommen.',
              }),
            )
            dispatch(closeConfirmationModal())
          })
          .catch((err) => console.log(err))
      })
      .catch((err) => log(err))
  }
  const handleChangeStripeElement = (e, field) => {
    setTouched({ ...touched, [field + 'Touched']: e?.complete ? true : false })
    e?.error?.message
      ? setErrors({
          ...errors,
          [field + 'Err']: e?.error?.message,
          stripeErrorMessage: e?.error?.message,
        })
      : setErrors({
          ...errors,
          [field + 'Err']: '',
          stripeErrorMessage:
            errors[arr.filter((err) => err !== field + 'Err')[0]] ||
            errors[arr.filter((err) => err !== field + 'Err')[1]] ||
            '',
        })
  }
  return (
    <div className={styles.form}>
      <div>
        <label>
          <span>Kartendaten</span>
          <div
            className={cx(styles.cardElementWrapper, {
              [styles.invalidElementWrapper]: errors.numberErr,
            })}
          >
            <CardNumberElement
              options={CARD_ELEMENT_OPTIONS}
              className={cx(styles.cardElement, {
                [styles.invalidElement]: errors.numberErr,
              })}
              onChange={(e) => handleChangeStripeElement(e, 'number')}
            />
          </div>
          <div>
            <div
              className={cx(styles.expiryWrapper, {
                [styles.invalidElementWrapper]: errors.expDateErr,
              })}
            >
              <CardExpiryElement
                options={CARD_ELEMENT_OPTIONS}
                className={cx(styles.expiredElement, {
                  [styles.invalidElement]: errors.expDateErr,
                })}
                onChange={(e) => handleChangeStripeElement(e, 'expDate')}
              />
            </div>
            <div
              className={cx(styles.cvcWrapper, {
                [styles.invalidElementWrapper]: errors.cvcErr,
              })}
            >
              <img src={Cvc} alt="CVC" />
              <CardCvcElement
                options={CARD_ELEMENT_OPTIONS}
                className={cx(styles.cvcElement, {
                  [styles.invalidElement]: errors.cvcErr,
                })}
                onChange={(e) => handleChangeStripeElement(e, 'cvc')}
              />
            </div>
          </div>
          {errors.stripeErrorMessage && (
            <span className={cx(styles.errorMessage)}>
              {errors.stripeErrorMessage}
            </span>
          )}
        </label>
      </div>
      <div>
        <label>
          <span>Name des/der Karteninhaber/in</span>
          <input
            type={'text'}
            value={name}
            onChange={(e) => handleName(e, 'name')}
            placeholder={'Vollständiger Name'}
            className={cx({
              [styles.invalidElement]: errors.nameErr,
            })}
          />
        </label>
      </div>
      <div className={styles.stripe}>
        <Link to={'https://stripe.com/'} target={'_blank'}>
          <span>Powered by</span>
          <img src={Stripe} alt={'Stripe'} />
        </Link>
      </div>
      <button
        className={cx(styles.button, {
          [styles.disabled]: disabled || !!disabledBtn,
        })}
        disabled={disabled || !!disabledBtn}
        onClick={handleConfirm}
      >
        Speichern
        {!!disabledBtn && <img src={Loading} alt={Loading} />}
      </button>
    </div>
  )
}

export default EditPaymentMethod
